export default __webpack_public_path__ + "static/media/pendente.71e081e7.svg";